import { CSSProperties } from 'react';

import { AppLayout, Banner, logos, ScrollableContainerWithFooter } from '@components';
import { AppHelper, UIHelper } from '@helpers';
import { useResponsive, useTranslation } from '@hooks';
import { useSearchParamsStore } from '@store';
import { ChallengeTypeEnum, CUSTOM_BREAKPOINT } from '@types';

import { MultichannelForm, PasswordForm } from './components';
import { UpdateCredentialsScreenProps } from './updateCredentials';

export const UpdateCredentialsScreenDesktop = ({ updateCredentialType }: UpdateCredentialsScreenProps) => {
	const { t } = useTranslation();
	const { windowWidth } = useResponsive();
	const clientId = useSearchParamsStore((store) => store.clientId);
	const isCorporateClient = AppHelper.isCorporateClient(t('configs.corporateClientsList'), clientId);
	const updateCredentialsForm = getUpdateCredentialsForm(updateCredentialType, isCorporateClient, windowWidth);

	return (
		<AppLayout styles={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
			<Banner />

			<ScrollableContainerWithFooter>{updateCredentialsForm}</ScrollableContainerWithFooter>
		</AppLayout>
	);
};

const getUpdateCredentialsForm = (
	updateCredentialType: ChallengeTypeEnum | null | undefined,
	isCorporateClient: boolean,
	windowWidth: number
) => {
	const LogoIcon = isCorporateClient ? logos.MbcpEmpresasLogo : logos.MbcpLogo;
	const logo = <LogoIcon width={228} height={56} />;

	const styles: CSSProperties = {
		overflowY: 'auto',
		flex: 1,
		padding: windowWidth > CUSTOM_BREAKPOINT ? UIHelper.rem(0, 120, 40) : UIHelper.rem(0, 24, 40),
		maxWidth: windowWidth > CUSTOM_BREAKPOINT ? UIHelper.rem(700) : UIHelper.rem(508),
	};

	return updateCredentialType === ChallengeTypeEnum.Password ? (
		<PasswordForm logo={logo} styles={styles} />
	) : (
		<MultichannelForm logo={logo} styles={styles} />
	);
};
